const TrustSection = () => {
  const benefits = [
    { icon: 'ri-price-tag-3-line', text: 'Wholesale trade line pricing' },
    { icon: 'ri-checkbox-circle-line', text: 'Done for you client fulfillment' },
    { icon: 'ri-line-chart-line', text: 'Broker profit margins built in' },
    { icon: 'ri-flashlight-line', text: 'Fast processing' },
    { icon: 'ri-customer-service-2-line', text: 'Dedicated broker support' },
  ];

  return (
    <section className="bg-[#F2F4F7] py-24">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="text-center mb-16">
          <h2 className="text-5xl font-bold text-[#2F6FE4] mb-4">
            Built for Business Credit Brokers
          </h2>
          <div className="w-16 h-1 bg-[#3D8BFF] mx-auto"></div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-5 gap-8">
          {benefits.map((benefit, index) => (
            <div
              key={index}
              className="flex flex-col items-center text-center space-y-4 p-6 bg-white rounded-xl shadow-lg hover:shadow-xl transition-shadow border-t-4 border-[#3D8BFF]"
            >
              <div className="w-20 h-20 flex items-center justify-center bg-[#A9C9FF] rounded-full">
                <i className={`${benefit.icon} text-4xl text-[#2F6FE4]`}></i>
              </div>
              <p className="text-[#555555] font-semibold text-base leading-snug">
                {benefit.text}
              </p>
            </div>
          ))}
        </div>

        {/* Financing Banner */}
        <div className="mt-14 flex justify-center">
          <div className="flex items-center gap-4 bg-white border-2 border-[#3D8BFF] px-8 py-5 rounded-2xl shadow-xl">
            <div className="w-12 h-12 flex items-center justify-center bg-[#A9C9FF] rounded-full flex-shrink-0">
              <i className="ri-funds-line text-[#2F6FE4] text-2xl"></i>
            </div>
            <div>
              <p className="text-[#2F6FE4] font-extrabold text-xl tracking-wide">Financing Available — Up to $100,000</p>
              <p className="text-[#555555] text-sm mt-0.5">Flexible financing options for your purchases. Apply today.</p>
            </div>
            <p className="text-[#555555] mb-6">
              Access up to $100,000 in financing for your business credit purchases. Fast approval process with competitive rates.
            </p>
            <a
              href="https://app.flexxbuy.com/fast-funding-capital-llc/apply/"
              target="_blank"
              rel="noopener noreferrer"
              className="bg-green-500 text-white px-8 py-3 rounded-full font-bold hover:bg-green-600 transition-all hover:scale-105 inline-flex items-center gap-2 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-funds-line text-lg"></i>
              Fund Me
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TrustSection;